module.exports = __webpack_public_path__ + "static/media/home_cn_bg1.e72fb84.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_cn_bg1.mp4
// module id = MBy9
// module chunks = 0